<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>
<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card">
            <!-- Title, filters and the page action share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Tariff Company</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <div class="btn-group sb-filter-search-group" role="group">
                        <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                            (input)="searchData($event)">
                        <button type="button" class="btn sb-filter-search-btn">
                            <!-- <i class="ri-search-line"></i> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-dark rounded" (click)="addTariffPopUp(content)"
                    *ngIf="permissionsReady && permissions.canAdd">
                    <i class="ri-add-line label-icon align-middle fs-16"></i>
                    Add New
                </button>
            </div>
            <!-- .table-wrap is position:relative, so the overlay is bounded by
                 the table instead of covering the page on every filter or
                 search keystroke. -->
            <div class="table-wrap" [class.is-loading]="tableLoader">
                <div class="loaderwrapper" *ngIf="tableLoader">
                    <span class="loader"></span>
                </div>
                <div class="table-main">
                    <table class="table-data">
                        <thead>
                            <tr>
                                <th scope="col">Sr. No</th>
                                <th scope="col">Company Name</th>

                                <th scope="col" style="width: 80px; text-align: center" *ngIf="hasAnyActionPermission">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of tariffList; let i = index">
                                <td>{{ item.srNo }}</td>

                                <td>{{ item.name }}</td>

                                <td *ngIf="hasAnyActionPermission">
                                    <ul class="list-inline hstack gap-2 mb-0">
                                        <li class="list-inline-item edit" data-bs-toggle="tooltip"
                                            data-bs-trigger="hover" data-bs-placement="top" title="Edit"
                                            *ngIf="permissionsReady && permissions.canEdit">
                                            <a title="Edit Teriff Company" class=" d-inline-block edit-item-btn"
                                                (click)="openEditPopUp(item, contentupdate)" data-toggle="modal"
                                                data-target="#edit-category-vt">
                                                <!-- <i class="ri-pencil-fill fs-16"></i> -->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14.433" height="18"
                                                    viewBox="8 4 14.433 18">
                                                    <path
                                                        d="M8.9 20.2h12.6a.9.9 0 0 1 0 1.8H8.9a.9.9 0 1 1 0-1.8ZM8 15.7l9-9 2.7 2.7-9 9H8v-2.7Zm9.9-9.9L19.7 4l2.7 2.7-1.8 1.8-2.7-2.7Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </a>
                                        </li>
                                        <li class="list-inline-item delete" data-bs-toggle="tooltip"
                                            data-bs-trigger="hover" data-bs-placement="top" title="Delete"
                                            *ngIf="permissionsReady && permissions.canDelete">
                                            <a title="Delete Tariff Company" data-bs-toggle="modal"
                                                class=" d-inline-block edit-item-btn"
                                                (click)="deleteTariffCompany(item.id)">
                                                <!-- <i class=" ri-close-circle-line  "></i>  -->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15.017" height="18"
                                                    viewBox="9 6 15.017 18">
                                                    <path
                                                        d="M10.5 22.004c0 1.098.9 1.996 2 1.996h8c1.1 0 2-.898 2-1.996V10.5h-12v11.504ZM24 7.5h-3.75L18.994 6h-4.988L12.75 7.5H9V9h15V7.5Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <!-- NO VIEW PERMISSION -->
                            <tr *ngIf="permissionsReady && !permissions.canView">
                                <td colspan="100%">
                                    <div class="no-access text-center p-4">
                                        You don’t have permission to view this data.
                                    </div>
                                </td>
                            </tr>

                            <!-- NO RECORDS -->
                            <tr
                                *ngIf="permissionsReady && permissions.canView && (!tariffList || tariffList.length === 0)">
                                <td colspan="100%">
                                    <p class="not-found-message p-4 text-center">
                                        No records found.
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-meta">
                    <div class="entries flex-column align-items-start gap-3">
                        <label class="show-entries-list p-0">
                            Show
                            <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                (change)="changePageSize()">
                                <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                    {{ limit.label }}
                                </option>
                            </select>
                            Entries
                        </label>
                        <span>Total Records: {{this.total_items }}</span>
                    </div>
                    <nav class="table-pagination">
                        <ul>
                            <li>
                                <div class="go-to-page d-flex align-items-center">
                                    <label>Go to Page:</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                        min="1" [max]="total_pages"
                                        (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                    <div class="input-group-append">
                                        <button class="btn btn-primary" type="button"
                                            (click)="goToPage(pageToGo); pageToGo = null"
                                            [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                    </div>
                                </div>
                            </li>
                            <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                    [class.disabled]="current_page === 1">1</a></li>
                            <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                        class="fa fa-chevron-left"></i></a></li>
                            <li><a class="active">{{ current_page }}</a></li>
                            <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                    [class.disabled]="current_page === total_pages"><i
                                        class="fa fa-chevron-right"></i></a>
                            </li>
                            <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                    [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                        </ul>
                    </nav>

                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #content let-c="close" let-d="dismiss">
    <form [formGroup]="addTariffCompanyForm" (ngSubmit)="onAddTariffCompany()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add Tariff Company</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); resetForm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">Company Name</label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="name"
                        maxlength="50" />

                    <small class="text-danger" *ngIf="
                        addTariffCompanyForm.get('name').hasError('required') &&
                            addTariffCompanyForm.get('name').touched
                        ">Please Enter Company Name</small>
                    <small class="text-danger" *ngIf="!addTariffCompanyForm.get('name').hasError('required') &&
                                addTariffCompanyForm.get('name').hasError('leadingWhitespace') &&                       
                                addTariffCompanyForm.get('name').touched">
                        Company name cannot be empty.
                    </small>
                    <small class="text-danger" *ngIf="addTariffCompanyForm.get('name').errors?.invalidInput">
                        Name cannot be whitespace or only numbers.
                    </small>
                    <small class="text-danger" *ngIf="addTariffCompanyForm.get('name').errors?.pattern">
                        Name can only contain alphabetic characters.
                    </small>
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="d('Cross click'); resetForm()">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="addTariffCompanyForm.invalid"
                (click)="d('Cross click')" type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>

<ng-template #contentupdate let-c="close" let-d="dismiss">
    <!-- (ngSubmit)="cardDetail(payment,content)" #payment="ngForm" -->
    <form [formGroup]="editTariffCompanyForm" (ngSubmit)="onUpdateTariffCompany()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
                Edit Tariff Company
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); resetForm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">Company Name</label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="name"
                        maxlength="50" />
                    <small class="text-danger" *ngIf="
                            editTariffCompanyForm.get('name').hasError('required') &&
                            editTariffCompanyForm.get('name').touched
                        ">Please Enter Company Name</small>
                    <small class="text-danger" *ngIf="!editTariffCompanyForm.get('name').hasError('required') &&
                        editTariffCompanyForm.get('name').hasError('leadingWhitespace') &&                       
                        editTariffCompanyForm.get('name').touched">
                        Company name cannot be empty.
                    </small>
                    <small class="text-danger" *ngIf="editTariffCompanyForm.get('name').errors?.invalidInput">
                        Name cannot be whitespace or only numbers.
                    </small>
                    <small class="text-danger" *ngIf="editTariffCompanyForm.get('name').errors?.pattern">
                        Name can only contain alphabetic characters.
                    </small>
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="d('Cross click'); resetForm()">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="editTariffCompanyForm.invalid"
                (click)="d('Cross click')" type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>